import React from "react";
import { useGetAllSubjects } from "../../../hooks/subjectHooks/subject.hooks";
import { ListTable } from "../../Table/listTable/listTable";
import { transformSubjectListTableData } from "../../../Services/transformer/transformSubjectListTableData";
import { subjectListTitles } from "../../../Constants/tableTitles/ListTableTitle/subjectList.titles";
import { useLocation } from "react-router-dom";
import { EditSubjectModal } from "../EditSubjectModal";

export const ListSubjects = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const page = parseInt(searchParams.get("page") || "") || 1;

  const [openEditModal, setOpenEditModal] = React.useState<boolean>(false);
  const [subjectDetailsToEdit, setSubjectDetailsToEdit] =
    React.useState<any>(null);

  const { isLoading: isSubjectsLoading, data } = useGetAllSubjects({ page });

  return (
    <>
      <ListTable
        titles={subjectListTitles}
        data={data?.result}
        isDataLoading={isSubjectsLoading}
        transformFn={transformSubjectListTableData}
        pagination={{
          onPageChange: (pageNo) => {},
          totalPage: data?.lastPage,
        }}
        moreOptons={{
          onEdit: (data: any) => {
            setSubjectDetailsToEdit(data);
            setOpenEditModal(true);
          },
          onRemove: (data: any) => {},
        }}
      />

      <EditSubjectModal
        open={openEditModal}
        onClose={() => {
          setOpenEditModal(false);
        }}
        subject={subjectDetailsToEdit}
      />
    </>
  );
};
